import Typography from "@mui/material/Typography";
import NavBar from "./NavBar";
 
import { useMsal } from "@azure/msal-react";

type Props = {
    children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({children}) => {
    const packageJson = require('../../package.json');
      const { instance, inProgress } = useMsal();
    
    return (
       
        <>
            <NavBar />
            <Typography variant="h6" align="center">
                <br/>
                {process.env.REACT_APP_MSAL_CLIENT_NAME} - Authentication TRIAL 
                <br/>
                v.{packageJson.version}
                <br/>
                <br/>{instance.getConfiguration().auth.clientId}
                <br/>{instance.getConfiguration().auth.authority}

            </Typography>
            <br/>
            <br/>
            {children}
        </>
    );
};